import * as React from 'react';

import { Typography } from '@mui/material';

import BaseDialog, { BaseDialogProps } from '../Base';
import { ProductRequestsContainer } from './components/ProductRequestsContainer';

export const ProductRequestsDialog: React.FC<BaseDialogProps> = (props) => {
  return (
    <BaseDialog
      {...props}
      width='1175px'
      height='850px'
      titleComponent={
        <Typography sx={{ fontSize: '18px', fontWeight: 500, fontFamily: 'Poppins' }}>
          History
        </Typography>
      }
      padding='8px 12px'
    >
      <ProductRequestsContainer />
    </BaseDialog>
  );
};
